import styled from 'styled-components';

import appTheme from '../../../themes/Theme';

export const StyledWrapper = styled.li`
  line-height: 26px;
  margin-bottom: 10px;
  color: ${appTheme.textColor};
`;
